(function () {
  'use strict';

  var EASE_OUT = function (t) {
    return 1 - (1 - t) * (1 - t);
  };

  function formatInteger(n) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(
      Math.round(n)
    );
  }

  function parseDecimalTarget(raw) {
    var v = parseFloat(String(raw || '').replace(',', '.'));
    return Number.isFinite(v) ? v : 0;
  }

  function animateValue(el, from, to, durationMs, onUpdate, done) {
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / durationMs);
      var eased = EASE_OUT(t);
      var current = from + (to - from) * eased;
      onUpdate(current);
      if (t < 1) {
        requestAnimationFrame(frame);
      } else if (typeof done === 'function') {
        done();
      }
    }
    requestAnimationFrame(frame);
  }

  function initRoot(root) {
    if (!root || root.dataset.counterInit === '1') return;
    root.dataset.counterInit = '1';

    var observer;
    var disposed = false;

    function run() {
      if (disposed || root.dataset.counterPlayed === '1') return;
      root.dataset.counterPlayed = '1';

      var durationBase = 1600;
      var cells = root.querySelectorAll('[data-counter-cell]');

      cells.forEach(function (cell) {
        var kind = cell.getAttribute('data-counter-kind');
        if (kind === 'static') return;

        var valueEl = cell.querySelector('[data-counter-value]');
        if (!valueEl) return;

        if (kind === 'integer') {
          var target = parseFloat(valueEl.getAttribute('data-target') || '0');
          if (!Number.isFinite(target)) target = 0;
          var showPlus = valueEl.getAttribute('data-show-plus') === 'true';
          var extra = valueEl.getAttribute('data-suffix') || '';
          var scale = Math.min(1.4, 0.35 + target / 25000);
          var duration = Math.round(durationBase * scale);

          animateValue(
            valueEl,
            0,
            target,
            duration,
            function (n) {
              valueEl.textContent = formatInteger(n) + (showPlus ? '+' : '') + extra;
            },
            function () {
              valueEl.textContent =
                formatInteger(target) + (showPlus ? '+' : '') + extra;
            }
          );
          return;
        }

        if (kind === 'decimal') {
          var rawTarget = valueEl.getAttribute('data-target') || '0';
          var to = parseDecimalTarget(rawTarget);
          var decimals = (String(rawTarget).split('.')[1] || '').length;
          if (decimals > 2) decimals = 2;
          if (decimals < 1) decimals = 1;

          animateValue(
            valueEl,
            0,
            to,
            1400,
            function (n) {
              valueEl.textContent = n.toFixed(decimals);
            },
            function () {
              valueEl.textContent = to.toFixed(decimals);
            }
          );
        }
      });
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run();
            if (observer) observer.disconnect();
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px' }
    );

    observer.observe(root);

    function dispose() {
      disposed = true;
      if (observer) observer.disconnect();
      observer = null;
      delete root.dataset.counterInit;
      delete root.dataset.counterPlayed;
    }

    root._counterAnimationDispose = dispose;
  }

  function boot() {
    document.querySelectorAll('[data-counter-animation-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector('[data-counter-animation-root]');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var root = ev.target && ev.target.querySelector('[data-counter-animation-root]');
    if (root && typeof root._counterAnimationDispose === 'function') {
      root._counterAnimationDispose();
    }
  });
})();
